import reducer from './tableServerRevision.reducer';

export default reducer;
